import { useSearchBox } from "react-instantsearch";

export function VirtualSearchBox () {
    useSearchBox();
    return null;
};